import posthog from 'posthog-js'

let isInitialized = false

function initializePosthog() {
  if (!isInitialized) {
    posthog.init(process.env.VUE_APP_POSTHOG_PROJECT_API_KEY, {
      api_host: process.env.VUE_APP_POSTHOG_API_HOST,
      autocapture: false,
      person_profiles: 'identified_only'
    })

    if (process.env.VUE_APP_POSTHOG_DEBUG === 'on') {
      posthog.debug(true)
    }

    isInitialized = true
  }
}

initializePosthog()

export { posthog }
